import {commitMutation, graphql} from 'react-relay';
import type {Environment} from 'relay-runtime';
import Util from '../forecast-app/shared/util/util';

const mutation = graphql`
	mutation updateXeroExportDefaultsMutation($input: UpdateXeroExportDefaultsInput!) {
		updateXeroExportDefaults(input: $input) {
			billFrom {
				id
				externalId
				integration
				exportProjectInDescription
			}
		}
	}
`;

type XeroExportDefaultsInput = {
	tenantId: string;
	projectInDescription: boolean;
};

function commit(
	environment: Environment,
	input: XeroExportDefaultsInput,
	onSuccess: (response: unknown) => void,
	onError: (error: Error) => void
) {
	return commitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		onCompleted: onSuccess,
		onError,
	});
}

export default {commit};
